export const ADD_QUERY_FILTER_PARAM = 'ADD_QUERY_FILTER_PARAM';
export const ADD_QUERY_PARAMS = 'ADD_QUERY_PARAMS';
export const SET_QUERY_SORT_PARAM = 'SET_QUERY_SORT_PARAM';

export const addQueryFilterParams = params => ({
    type: ADD_QUERY_PARAMS,
    payload: params
});

export const addQueryFilterParam = param => ({
    type: ADD_QUERY_FILTER_PARAM,
    payload: {
        [param.index]: param.value,
    }
});

export const setQuerySortParam = param => ({
    type: SET_QUERY_SORT_PARAM,
    payload: {
        sortDirection: param.direction,
    }
});
